import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '../../atoms/Skeleton';
import '../Browse/browse.css';
import './productDetailView.css';

/* ProductDetailViewSkeleton — the product page's own shape while it loads.

   It draws this page, not a generic one: the loader it replaces drew a two-column
   grid with a 60px thumbnail rail, five swatch pills and a tab bar, none of which
   this page has, so the screen rearranged when the product arrived. These blocks
   sit in the real `.pp-*` boxes.

   The region is announced once and the blocks never: `Skeleton` is `aria-hidden`,
   and `aria-busy` on the wrapper is what a screen reader reads. */
export default function ProductDetailViewSkeleton({ thumbs }) {
  return (
    <div className="br-wrap pp-wrap" aria-busy="true" aria-live="polite" aria-label="Loading product">
      <Skeleton w={220} h={13} style={{ margin: '0 0 18px' }} />

      <div className="pp-top">
        <div className="pp-gal">
          <div className="pp-thumbsw">
            <div className="pp-thumbs">
              {[...Array(thumbs)].map((_, i) => (
                <Skeleton key={i} w={68} h={68} shape="tile" style={{ flex: '0 0 68px' }} />
              ))}
            </div>
          </div>
          <Skeleton className="pp-hero" shape="tile" w="100%" h="auto" />
        </div>

        <div className="pp-buy">
          <Skeleton w={150} h={30} shape="circle" style={{ display: 'block' }} />
          <Skeleton w="82%" h={30} style={{ display: 'block', margin: '5px 0 0' }} />
          <Skeleton w={110} h={24} style={{ display: 'block' }} />

          <div className="pp-opt">
            <Skeleton w={70} h={12} style={{ display: 'block', marginBottom: 8 }} />
            <div className="pp-optvals">
              {[64, 78, 58].map((w, i) => <Skeleton key={i} w={w} h={31} shape="circle" />)}
            </div>
          </div>

          <div className="pp-addrow">
            <Skeleton w={120} h={41} shape="tile" />
            <Skeleton h={45} shape="tile" style={{ flex: 1 }} />
          </div>

          <ul className="pp-trust">
            <li><Skeleton w="88%" h={12} /></li>
            <li><Skeleton w="54%" h={12} /></li>
          </ul>
        </div>
      </div>

      <div className="pp-accs">
        {[...Array(4)].map((_, i) => (
          <div className="pp-acc" key={i}>
            <div className="pp-acch"><Skeleton w={190} h={17} /></div>
          </div>
        ))}
      </div>
    </div>
  );
}

ProductDetailViewSkeleton.propTypes = { thumbs: PropTypes.number };
ProductDetailViewSkeleton.defaultProps = { thumbs: 4 };
